// frontend/src/services/admin.js
import { apiClient } from '../api';

const adminApiService = {
  // --- AI MODEL MANAGEMENT ---
  listAllModelConfigsAdmin: async () => {
    return await apiClient.get('/admin/models/');
  },

  createModelConfigAdmin: async (data) => {
    return await apiClient.post('/admin/models/', data);
  },

  toggleModelActiveStatusAdmin: async (modelId) => {
    return await apiClient.put(`/admin/models/${modelId}/toggle-active`, {});
  },

  deleteModelConfigAdmin: async (modelId) => {
    return await apiClient.delete(`/admin/models/${modelId}`);
  },
  
  // --- NEW METHOD ---
  deactivateAllModels: async () => {
      return await apiClient.put('/admin/models/deactivate-all', {});
  },

  // --- AI PROVIDER SWITCH (OpenRouter or Google Gemini) ---
  // Which company is answering right now, and are both keys present.
  getAiProvider: async () => {
      return await apiClient.get('/admin/models/provider');
  },

  // Flips the whole app to the other AI company.
  setAiProvider: async (provider) => {
      return await apiClient.put('/admin/models/provider', { provider });
  },

  // --- MODEL CATALOG ---
  // Every model the chosen company can reach with your key, fetched live.
  // Pass provider to preview the other company's list without switching.
  getOpenRouterCatalog: async ({ search = '', toolsOnly = false, freeOnly = false, provider = '' } = {}) => {
      const params = new URLSearchParams();
      if (search) params.set('search', search);
      if (toolsOnly) params.set('tools_only', 'true');
      if (freeOnly) params.set('free_only', 'true');
      if (provider) params.set('provider', provider);
      return await apiClient.get(`/admin/models/catalog?${params.toString()}`);
  },

  // Saves several catalog models into the registered list at once.
  importModels: async (models) => {
      return await apiClient.post('/admin/models/import', { models });
  },

  // Sends one short message to a model to see if it answers.
  testModel: async (apiModelName) => {
      return await apiClient.post('/admin/models/test', { api_model_name: apiModelName });
  },

  // Is the chosen company's key set, and does the default model reply?
  getAiHealth: async () => {
      return await apiClient.get('/admin/models/health');
  },

  // --- EXISTING METHODS (Keep these if used elsewhere, or remove if unused) ---
  // For now, we keep the structure clean.
};

export default adminApiService;